import { useCallback, useEffect, useRef } from "react";

declare global {
  interface Window {
    grecaptcha: {
      ready: (cb: () => void) => void;
      render: (
        container: HTMLElement,
        parameters: {
          sitekey: string;
          theme: "dark" | "light";
          size: "compact" | "normal";
          callback: (token: string) => void;
          "expired-callback": () => void;
        },
      ) => number;
    };
  }
}

const SITE_KEY = process.env.PUBLIC_RECAPTCHA_SITE_KEY ?? "";

export function useRecaptcha(): () => Promise<string> {
  const tokenRef = useRef("");

  useEffect(() => {
    const container = document.getElementById("recaptcha-container");
    if (!SITE_KEY || !container || document.getElementById("recaptcha-script")) return;

    const script = document.createElement("script");
    script.id = "recaptcha-script";
    script.src = "https://www.google.com/recaptcha/api.js?render=explicit";
    script.onload = () => {
      window.grecaptcha.ready(() => {
        window.grecaptcha.render(container, {
          sitekey: SITE_KEY,
          theme: "dark",
          size: "compact",
          callback: (token) => {
            tokenRef.current = token;
          },
          "expired-callback": () => {
            tokenRef.current = "";
          },
        });
      });
    };
    document.head.appendChild(script);
  }, []);

  return useCallback((): Promise<string> => Promise.resolve(tokenRef.current), []);
}
